import Vue from 'vue'
import VueRouter from 'vue-router'
import iView from 'view-design'
import routes from './routes'
import store from '@/store'

Vue.use(VueRouter)


const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

router.beforeEach(routeGuard);

async function routeGuard(to, from, next) {
    iView.LoadingBar.start();
   
    const TOKEN = cookie.get('token'); // 获取token

    if (!TOKEN && to.name != 'login') {
        // 未登录且要跳转的页面不是登录页, 则去登录
        next({name:'login'});   
    }else if(!TOKEN && to.name=='login'){
        // 登录
        next();
    }else if (TOKEN && to.name=='login'){
        // 已登录且要跳转的页面是登录页
        next('/admin');
    }else{
        if (!store.getters['user/info']){
            await store.dispatch('user/get_info',cookie.get('uid'));
            
        }
        next();
    }

    
    next();
}

router.afterEach(to => {
    // 路由发生变化修改页面title 
    document.title = to.meta.title ? `${to.meta.title} - ${option.title}` : option.title;
    iView.LoadingBar.finish();
});


export default router;